
export enum RuleStatus {
  Rebuildable = 1,
  System = 2,
  Hammer = 4,
  Enabled = 16,
  Validated = 32,
  Test = 128
}
